<template>
  <div>
    <XVactionbar>
      <template slot="actionbuttons">
        <div class="btn-group">
          <button type="button" class="btn btn-primary btn-xs" @click="btnOk" :class="{ DisabledItem: btnokdisabled }">
            <font-awesome-icon :icon="['far', 'check']" />
            {{ translation(12980) }}
          </button>
          <button type="button" class="btn btn-primary btn-xs" @click="btnTerug">
            <font-awesome-icon icon="chevron-left" />
            {{ translation(177) }}
          </button>
        </div>
      </template>
    </XVactionbar>
    <div class="row">
      <div class="col-md-12">
        <span id="lblTitel" class="titel">{{ translation(5021) }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <p v-html="translation(11986)"></p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <fieldset>
          <div class="row margin20">
            <div class="col-md-4">
              <label>{{ translation(5025) }} *</label>
              <span class="pull-right">
                <XVhelpcontrol :helptext="translation(5030)"></XVhelpcontrol>
              </span>
            </div>
            <div class="col-md-8 form-group has-feedback" v-if="myAdminsInstitutes.length > 1">
              <XVdropdownsearch
                id="dlMyAdminsInstitute2"
                :datalist="myAdminsInstitutes"
                :value="dlSelected"
                @input="SelectInstitute"
              ></XVdropdownsearch>
            </div>
            <div class="col-md-8 form-group has-feedback" v-if="myAdminsInstitutes.length === 1">
              {{ myAdminsInstitutes[0].labelText }}
            </div>
          </div>
          <div class="row" v-if="dlSelected !== '' || myAdminsInstitutes.length === 1">
            <div class="col-md-4">
              <label>{{ translation(4923) }} *</label>
              <span class="pull-right">
                <XVhelpcontrol :helptext="translation(5031)"></XVhelpcontrol>
              </span>
            </div>
            <div class="col-md-8">
              <div class="row" v-if="filteredMentors.length > 1">
                <div class="col-md-12 form-group has-feedback">
                  <XVinput
                    id="input"
                    @input="setmentorSearch"
                    :value="mentorSearch"
                    :placeholder="translation(5494) + ' op naam'"
                  ></XVinput>
                </div>
              </div>
              <div class="row" v-if="!filteredMentors[0] && ddLoaded">
                <div class="col-md-12 form-group has-feedback">
                  <p>{{ translation(11911) }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div
                    class="row checkboxclass"
                    v-for="(mentor, index) in filteredMentors.filter(
                      (mentor) => mentor.visible || toggleDateRowSelected(mentor)
                    )"
                    :key="mentor.adminID"
                  >
                    <div class="col-md-12 form-group has-feedback">
                      <span class="XVcheckbox pointer">
                        <span class="radioholder" @click="toggleDateRowByID(mentor)">
                          <span class="squaredFour pointer">
                            <input
                              :id="'cbMentors' + index"
                              :value="mentor.adminID"
                              :checked="toggleDateRowSelected(mentor)"
                              type="checkbox"
                            />
                            <label></label>
                          </span>
                        </span>
                      </span>
                      &nbsp;{{ mentor.tblPersonName }}&nbsp;({{ mentor.roles | arrayToString }})
                      <div class="row margin10" v-if="toggleDateRowSelected(mentor)">
                        <div class="col-md-4">
                          <label>{{ translation(5026) }}</label>
                          <span class="pull-right">
                            <XVhelpcontrol :helptext="translation(5029)"></XVhelpcontrol>
                          </span>
                        </div>
                        <div
                          class="col-md-8 form-group has-feedback"
                          v-bind:class="{ 'form-group--error': errors.has('tbxDatum' + index) }"
                        >
                          <XVdate
                            :id="'tbxDatum_' + index"
                            v-model="mentor.mentorDatum"
                            :name="'tbxDatum' + index"
                            data-vv-as="Datum"
                            v-validate="{ XVDateDefault: true }"
                          ></XVdate>
                          <span class="form-group__message">{{ errors.first('tbxDatum' + index) }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</template>

<script>
'use strict'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { FAMixin, util } from 'pevueglobal'

export default {
  mixins: [FAMixin],
  data: function () {
    return {}
  },
  computed: {
    ...mapGetters('Spe671PrExtOrgMyAdmins', [
      'myAdminsInstitutes',
      'mentorSearch',
      'dlSelected',
      'toggleDateRow',
      'toggleDateRowSelected',
      'filteredMentors',
      'ddLoaded',
    ]),
    btnokdisabled: function () {
      return this.toggleDateRow.length === 0
    },
  },
  filters: {
    arrayToString: function (ar) {
      let arStr = ''
      if (ar === undefined) {
        return arStr
      }
      ar.forEach((val) => {
        arStr += val + ', '
      })
      arStr = arStr.substring(0, arStr.length - 2)
      return arStr
    },
  },
  async mounted() {
    await this.getInstitutes()
    this.stopLoading()
  },
  methods: {
    ...mapActions('Spe671PrExtOrgMyAdmins', ['getInstitutes', 'getMentor', 'setMentor']),
    ...mapMutations('Spe671PrExtOrgMyAdmins', [
    'setmentorSearch',
      'setdlSelected',
      'setToggleDateRow',
      'toggleDateRowByID',
    ]),
    ...mapMutations(['addNotification']),
    SelectInstitute: function (value) {
      this.setdlSelected(value)

      this.getMentor({
        SelectedInstituutID: this.dlSelected,
      })
    },
    btnOk: function () {
      let mentorSave = this.toggleDateRow.map((mentor) => {
        return { intvalue: mentor.adminID, datevalue: util.DateForDatabase(mentor.mentorDatum) }
      })

      if (this.errors.items.length === 0) {
        this.setMentor({ DateUpToAndAdminID: mentorSave })
      } else {
        this.addNotification({
          groupname: 'warning',
          message: this.translation(14642),
        })
      }
    },
    btnTerug: function () {
      this.$router.push({ name: 'Spe671PrExtOrgMyAdmins' })
    },
  },
}
</script>
